import styled from '@emotion/styled';
import { Icon, tokens } from '@hotjar/hotsauce';

export const HeroWrapper = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  background-color: ${tokens.color.ui_background};
  padding: ${tokens.spacer.x3};
  border: 1px solid ${tokens.color.ui_border};
  border-radius: ${tokens.radius.l};
  margin-bottom: ${tokens.spacer.x3};
`;

export const HeroCopyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-left: ${tokens.spacer.x2};
`;

export const InstallationIcon = styled(Icon)`
  color: ${tokens.color.ember_600};
`;
